import hljs from 'highlight.js/lib/core';
import ruby from 'highlight.js/lib/languages/ruby';
import 'highlight.js/styles/atom-one-dark';

window.hljs = hljs

hljs.registerLanguage('ruby', ruby);

const init = function() {
  hljs.highlightAll();
}

$(document).ready(function () {
  init()
  $(document).on("turbo:load", init);
  $(document).on("turbo:frame-load", init); // modal shown
})

